import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const notificationApiService = createApi({
  reducerPath: 'notificationApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/notification/'),
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: () => `get`
    })
  })
})

export const {
  useGetNotificationsQuery,
} = notificationApiService